import { generateBaseQueryKeysList } from '@/queries/utils';

export const DEVICE_TRACKING_KEYS = {
  main: 'device-tracking',
  case: 'case',
  logs: 'logs',
};

export const deviceTrackingQueryKeys = {
  ...generateBaseQueryKeysList(DEVICE_TRACKING_KEYS.main),
  getByCaseId: (...args: unknown[]) => [DEVICE_TRACKING_KEYS.main, DEVICE_TRACKING_KEYS.case, ...args],
  getLogsById: (...args: unknown[]) => [DEVICE_TRACKING_KEYS.main, DEVICE_TRACKING_KEYS.logs, ...args],
};
